module.exports = __webpack_public_path__ + "img/dj.a85f531a.svg";